import { useContext } from 'react'
import { AIConfigContext } from '@/context/AIConfigProvider'

/**
 * Hook for accessing AI-generated configuration data for pages and templates.
 * Must be used within an AIConfigProvider (which must be a child of OnboardingContextProvider).
 * 
 * @returns {Object} Context value containing:
 *   - data: The full AI config data object
 *   - get: Function to safely retrieve nested values (like lodash.get)
 *   - has: Function to check if a path exists
 *   - isLoading: Boolean indicating if data is being fetched
 *   - isLoaded: Boolean indicating if data has been loaded
 *   - error: Any error that occurred during fetch
 * 
 * @example
 * const { get, has, isLoading } = useAIConfig()
 * const headline = get('pages.home.hero.headline', 'Default Headline')
 * const features = get('pages.home.features', [])
 */
const useAIConfig = () => {
  const context = useContext(AIConfigContext)
  
  if (context === undefined) {
    throw new Error('useAIConfig must be used within an AIConfigProvider')
  }
  
  return context
}

export default useAIConfig
